// COPIED from ptc-core web/src/components/dates/isoDate.ts @ a29ddc0 (#355), unchanged: split out of
// CalendarDateInput.tsx so that file exports only the component (react-refresh).
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/** A real calendar date in `yyyy-MM-dd` (rejects 2026-02-30). */
export function isIsoDate(text: string): boolean {
  const m = ISO_DATE.exec(text);
  if (!m) return false;
  const d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
  return d.getUTCFullYear() === +m[1] && d.getUTCMonth() === +m[2] - 1 && d.getUTCDate() === +m[3];
}
